
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    labelFor: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
  },
}
